"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indicatorIdToIndicatorCategoryMap = void 0;
const types_1 = require("./types");
exports.indicatorIdToIndicatorCategoryMap = {
    [types_1.IndicatorId.BounceRate]: types_1.IndicatorCategory.BounceRate,
    [types_1.IndicatorId.RevisitRate]: types_1.IndicatorCategory.RevisitRate,
    [types_1.IndicatorId.NumberOfViewedPages]: types_1.IndicatorCategory.PagesViewed,
};
//# sourceMappingURL=constants.js.map